const LogoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 0.5H8V4.5H4H0V8.5V12.5V16.5H4H8V12.5H12H16V8.5V4.5V0.5H12ZM4 12.5H8V8.5H12V4.5H8V8.5H4V12.5Z"
        fill="white"
      />
    </svg>
  );
};
const GitHubIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C6.475 2 2 6.475 2 12C2 16.425 4.8625 20.1625 8.8375 21.4875C9.3375 21.575 9.525 21.275 9.525 21.0125C9.525 20.775 9.5125 19.9875 9.5125 19.15C7 19.6125 6.35 18.5375 6.15 17.975C6.0375 17.6875 5.55 16.8 5.125 16.5625C4.775 16.375 4.275 15.9125 5.1125 15.9C5.9 15.8875 6.4625 16.625 6.65 16.925C7.55 18.4375 8.9875 18.0125 9.5625 17.75C9.65 17.1 9.9125 16.6625 10.2 16.4125C7.975 16.1625 5.65 15.3 5.65 11.475C5.65 10.3875 6.0375 9.4875 6.675 8.7875C6.575 8.5375 6.225 7.5125 6.775 6.1375C6.775 6.1375 7.6125 5.875 9.525 7.1625C10.325 6.9375 11.175 6.825 12.025 6.825C12.875 6.825 13.725 6.9375 14.525 7.1625C16.4375 5.8625 17.275 6.1375 17.275 6.1375C17.825 7.5125 17.475 8.5375 17.375 8.7875C18.0125 9.4875 18.4 10.375 18.4 11.475C18.4 15.3125 16.0625 16.1625 13.8375 16.4125C14.2 16.725 14.5125 17.325 14.5125 18.2625C14.5125 19.6 14.5 20.675 14.5 21.0125C14.5 21.275 14.6875 21.5875 15.1875 21.4875C17.1727 20.8173 18.8977 19.5415 20.1198 17.8395C21.3419 16.1376 21.9995 14.0953 22 12C22 6.475 17.525 2 12 2Z"
        fill="black"
      />
    </svg>
  );
};
const GitHubWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M24.0432 0.179932C10.8147 0.179932 0.0876465 11.0878 0.0876465 24.5445C0.0876465 35.3096 6.95165 44.4426 16.4699 47.6643C17.6672 47.8899 18.1067 47.1358 18.1067 46.4922C18.1067 45.9112 18.0845 43.9919 18.0742 41.956C11.4097 43.4299 10.0034 39.0812 10.0034 39.0812C8.9137 36.265 7.34358 35.5161 7.34358 35.5161C5.17009 34.0039 7.50742 34.035 7.50742 34.035C9.91297 34.2065 11.1796 36.5458 11.1796 36.5458C13.3162 40.2707 16.7837 39.1938 18.1507 38.5712C18.3657 36.9969 18.9866 35.9212 19.6716 35.3132C14.3508 34.6971 8.7574 32.6079 8.7574 23.2719C8.7574 20.6118 9.6932 18.4383 11.2256 16.732C10.9769 16.1179 10.1569 13.6402 11.4577 10.2841C11.4577 10.2841 13.4693 9.62928 18.0472 12.7816C19.9581 12.2418 22.0074 11.971 24.0432 11.9618C26.0791 11.971 28.13 12.2418 30.0444 12.7816C34.6167 9.62928 36.6256 10.2841 36.6256 10.2841C37.9295 13.6402 37.1091 16.1179 36.8604 16.732C38.3964 18.4383 39.3259 20.6118 39.3259 23.2719C39.3259 32.6301 33.7218 34.6906 28.3874 35.2938C29.2467 36.0499 30.0123 37.5327 30.0123 39.8059C30.0123 43.0655 29.9845 45.6893 29.9845 46.4922C29.9845 47.1406 30.4157 47.9003 31.63 47.6611C41.1431 44.4357 47.9984 35.3059 47.9984 24.5445C47.9984 11.0878 37.273 0.179932 24.0432 0.179932Z"
        fill="white"
      />
    </svg>
  );
};
const FigmaIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24ZM39.0621 23.0815C39.059 30.9483 32.6595 37.3493 24.7911 37.3525H24.7852C22.3967 37.3517 20.0498 36.7524 17.9653 35.6155L10.4 37.6L12.4246 30.2048C11.1757 28.0405 10.5186 25.5855 10.5196 23.0702C10.5228 15.2017 16.9248 8.8 24.7909 8.8C28.6086 8.80165 32.1918 10.2879 34.8862 12.9854C37.5806 15.6828 39.0637 19.2683 39.0621 23.0815Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8265 34.2096L18.3159 33.0319L18.749 33.289C20.5702 34.3697 22.6578 34.9415 24.7863 34.9424H24.7911C31.3289 34.9424 36.6499 29.6212 36.6526 23.0807C36.6538 19.9112 35.4212 16.9311 33.1817 14.689C30.9422 12.4469 27.964 11.2115 24.7958 11.2104C18.2529 11.2104 12.9318 16.5311 12.9292 23.0711C12.9283 25.3124 13.5554 27.4951 14.7428 29.3836L15.0248 29.8324L13.8265 34.2096ZM31.4924 26.1541C31.7411 26.2743 31.9091 26.3554 31.9808 26.4751C32.0699 26.6238 32.0699 27.3378 31.7729 28.1709C31.4756 29.0038 30.0511 29.764 29.3659 29.8663C28.7516 29.9582 27.9742 29.9965 27.12 29.725C26.602 29.5607 25.9379 29.3413 25.0871 28.9739C21.7442 27.5304 19.4851 24.2904 19.0581 23.678C19.0282 23.6351 19.0072 23.6051 18.9956 23.5896L18.9927 23.5857C18.804 23.3339 17.5395 21.6468 17.5395 19.9008C17.5395 18.2583 18.3464 17.3973 18.7178 17.001C18.7432 16.9739 18.7666 16.9489 18.7876 16.926C19.1144 16.569 19.5008 16.4798 19.7385 16.4798C19.9762 16.4798 20.2141 16.482 20.4219 16.4924C20.4475 16.4937 20.4742 16.4935 20.5018 16.4934C20.7096 16.4921 20.9686 16.4906 21.2242 17.1045C21.3225 17.3408 21.4664 17.691 21.6181 18.0603C21.9249 18.8074 22.264 19.6328 22.3236 19.7522C22.4128 19.9307 22.4722 20.1389 22.3534 20.377C22.3355 20.4127 22.319 20.4464 22.3032 20.4785C22.214 20.6608 22.1483 20.7949 21.9968 20.9718C21.9372 21.0414 21.8756 21.1164 21.814 21.1913C21.6914 21.3407 21.5687 21.4901 21.4619 21.5965C21.2834 21.7743 21.0975 21.9673 21.3055 22.3243C21.5135 22.6813 22.2292 23.8489 23.2893 24.7945C24.4288 25.8109 25.4192 26.2405 25.9212 26.4583C26.0192 26.5008 26.0986 26.5352 26.1569 26.5644C26.5133 26.7429 26.7214 26.7131 26.9294 26.4751C27.1374 26.2372 27.8208 25.4339 28.0585 25.0769C28.2961 24.7201 28.534 24.7795 28.8608 24.8985C29.1877 25.0176 30.9408 25.8801 31.2974 26.0586C31.367 26.0935 31.4321 26.1249 31.4924 26.1541Z"
        fill="black"
      />
    </svg>
  );
};
const FigmaWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24ZM39.0621 23.0815C39.059 30.9483 32.6595 37.3493 24.7911 37.3525H24.7852C22.3967 37.3517 20.0498 36.7524 17.9653 35.6155L10.4 37.6L12.4246 30.2048C11.1757 28.0405 10.5186 25.5855 10.5196 23.0702C10.5228 15.2017 16.9248 8.8 24.7909 8.8C28.6086 8.80165 32.1918 10.2879 34.8862 12.9854C37.5806 15.6828 39.0637 19.2683 39.0621 23.0815Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8265 34.2096L18.3159 33.0319L18.749 33.289C20.5702 34.3697 22.6578 34.9415 24.7863 34.9424H24.7911C31.3289 34.9424 36.6499 29.6212 36.6526 23.0807C36.6538 19.9112 35.4212 16.9311 33.1817 14.689C30.9422 12.4469 27.964 11.2115 24.7958 11.2104C18.2529 11.2104 12.9318 16.5311 12.9292 23.0711C12.9283 25.3124 13.5554 27.4951 14.7428 29.3836L15.0248 29.8324L13.8265 34.2096ZM31.4924 26.1541C31.7411 26.2743 31.9091 26.3554 31.9808 26.4751C32.0699 26.6238 32.0699 27.3378 31.7729 28.1709C31.4756 29.0038 30.0511 29.764 29.3659 29.8663C28.7516 29.9582 27.9742 29.9965 27.12 29.725C26.602 29.5607 25.9379 29.3413 25.0871 28.9739C21.7442 27.5304 19.4851 24.2904 19.0581 23.678C19.0282 23.6351 19.0072 23.6051 18.9956 23.5896L18.9927 23.5857C18.804 23.3339 17.5395 21.6468 17.5395 19.9008C17.5395 18.2583 18.3464 17.3973 18.7178 17.001C18.7432 16.9739 18.7666 16.9489 18.7876 16.926C19.1144 16.569 19.5008 16.4798 19.7385 16.4798C19.9762 16.4798 20.2141 16.482 20.4219 16.4924C20.4475 16.4937 20.4742 16.4935 20.5018 16.4934C20.7096 16.4921 20.9686 16.4906 21.2242 17.1045C21.3225 17.3408 21.4664 17.691 21.6181 18.0603C21.9249 18.8074 22.264 19.6328 22.3236 19.7522C22.4128 19.9307 22.4722 20.1389 22.3534 20.377C22.3355 20.4127 22.319 20.4464 22.3032 20.4785C22.214 20.6608 22.1483 20.7949 21.9968 20.9718C21.9372 21.0414 21.8756 21.1163 21.814 21.1913C21.6914 21.3407 21.5687 21.4901 21.4619 21.5965C21.2834 21.7743 21.0975 21.9673 21.3055 22.3243C21.5135 22.6813 22.2292 23.8489 23.2893 24.7945C24.4288 25.8109 25.4192 26.2405 25.9212 26.4583C26.0192 26.5008 26.0986 26.5352 26.1569 26.5644C26.5133 26.7429 26.7214 26.7131 26.9294 26.4751C27.1374 26.2372 27.8208 25.4339 28.0585 25.0769C28.2961 24.7201 28.534 24.7795 28.8608 24.8985C29.1877 25.0176 30.9408 25.8801 31.2974 26.0586C31.367 26.0935 31.4321 26.1249 31.4924 26.1541Z"
        fill="white"
      />
    </svg>
  );
};
const LinkedinIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M22 3.47059V20.5294C22 20.9194 21.8451 21.2935 21.5693 21.5693C21.2935 21.8451 20.9194 22 20.5294 22H3.47059C3.08056 22 2.70651 21.8451 2.43073 21.5693C2.15494 21.2935 2 20.9194 2 20.5294V3.47059C2 3.08056 2.15494 2.70651 2.43073 2.43073C2.70651 2.15494 3.08056 2 3.47059 2H20.5294C20.9194 2 21.2935 2.15494 21.5693 2.43073C21.8451 2.70651 22 3.08056 22 3.47059ZM7.88235 9.64706H4.94118V19.0588H7.88235V9.64706ZM8.14706 6.41177C8.14861 6.18929 8.10632 5.96869 8.02261 5.76255C7.93891 5.55642 7.81542 5.36879 7.65919 5.21039C7.50297 5.05198 7.31708 4.92589 7.11213 4.83933C6.90718 4.75277 6.68718 4.70742 6.46471 4.70588H6.41177C5.95934 4.70588 5.52544 4.88561 5.20552 5.20552C4.88561 5.52544 4.70588 5.95934 4.70588 6.41177C4.70588 6.86419 4.88561 7.29809 5.20552 7.61801C5.52544 7.93792 5.95934 8.11765 6.41177 8.11765C6.63426 8.12312 6.85565 8.0847 7.06328 8.00458C7.27092 7.92447 7.46074 7.80422 7.62189 7.65072C7.78304 7.49722 7.91237 7.31346 8.00248 7.10996C8.09259 6.90646 8.14172 6.6872 8.14706 6.46471V6.41177ZM19.0588 13.3412C19.0588 10.5118 17.2588 9.41177 15.4706 9.41177C14.8851 9.38245 14.3021 9.50715 13.7799 9.77345C13.2576 10.0397 12.8143 10.4383 12.4941 10.9294H12.4118V9.64706H9.64706V19.0588H12.5882V14.0529C12.5457 13.5403 12.7072 13.0315 13.0376 12.6372C13.3681 12.2429 13.8407 11.9949 14.3529 11.9471H14.4647C15.4 11.9471 16.0941 12.5353 16.0941 14.0176V19.0588H19.0353L19.0588 13.3412Z"
        fill="black"
      />
    </svg>
  );
};
const LinkedinWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM11.5216 19.8778H16.9605V36.2196H11.5216V19.8778ZM17.3188 14.8227C17.2835 13.2204 16.1377 12 14.277 12C12.4164 12 11.2 13.2204 11.2 14.8227C11.2 16.3918 12.3805 17.6473 14.2064 17.6473H14.2412C16.1377 17.6473 17.3188 16.3918 17.3188 14.8227ZM30.3131 19.4941C33.8922 19.4941 36.5754 21.8303 36.5754 26.8497L36.5752 36.2196H31.1365V27.4767C31.1365 25.2807 30.3494 23.7822 28.3805 23.7822C26.8779 23.7822 25.9829 24.7924 25.5898 25.7682C25.446 26.1178 25.4107 26.605 25.4107 27.0934V36.22H19.9711C19.9711 36.22 20.0428 21.4117 19.9711 19.8783H25.4107V22.1929C26.1325 21.0802 27.4254 19.4941 30.3131 19.4941Z"
        fill="white"
      />
    </svg>
  );
};
const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM9.29289 7.70711C8.90237 7.31658 8.90237 6.68342 9.29289 6.29289C9.68342 5.90237 10.3166 5.90237 10.7071 6.29289L13.7071 9.29289C14.0976 9.68342 14.0976 10.3166 13.7071 10.7071L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071C8.90237 13.3166 8.90237 12.6834 9.29289 12.2929L10.5858 11H7C6.44772 11 6 10.5523 6 10C6 9.44771 6.44772 9 7 9H10.5858L9.29289 7.70711Z"
        fill="white"
      />
    </svg>
  );
};
const LiveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="black"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7ZM7 4C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17C18.6569 20 20 18.6569 20 17V7C20 5.34315 18.6569 4 17 4H7ZM6.79289 8.29289C7.18342 7.90237 7.81658 7.90237 8.20711 8.29289L11.2071 11.2929C11.5976 11.6834 11.5976 12.3166 11.2071 12.7071L8.20711 15.7071C7.81658 16.0976 7.18342 16.0976 6.79289 15.7071C6.40237 15.3166 6.40237 14.6834 6.79289 14.2929L9.08579 12L6.79289 9.70711C6.40237 9.31658 6.40237 8.68342 6.79289 8.29289ZM17.2071 8.29289C17.5976 8.68342 17.5976 9.31658 17.2071 9.70711L14.9142 12L17.2071 14.2929C17.5976 14.6834 17.5976 15.3166 17.2071 15.7071C16.8166 16.0976 16.1834 16.0976 15.7929 15.7071L12.7929 12.7071C12.4024 12.3166 12.4024 11.6834 12.7929 11.2929L15.7929 8.29289C16.1834 7.90237 16.8166 7.90237 17.2071 8.29289Z"
        
      />
    </svg>
  );
};
const AzerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="513"
      height="114"
      viewBox="0 0 513 114"
      fill="none"
    >
      <path d="M0 -0.00585938H513V113.994H0V-0.00585938Z" fill="#00B5E2" />
    </svg>
  );
};
const ArrayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="202"
      height="203"
      viewBox="0 0 202 203"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M170.851 117.989C170.851 117.989 170.851 117.989 170.667 118.171C170.598 118.414 170.597 118.414 170.597 118.414L170.584 118.412L170.544 118.405L170.386 118.376C170.248 118.352 170.043 118.316 169.781 118.271C169.256 118.182 168.498 118.058 167.569 117.919C165.711 117.641 163.169 117.303 160.431 117.061C157.692 116.819 154.762 116.675 152.128 116.782C149.484 116.891 147.174 117.253 145.652 118.001L145.477 117.561C147.106 116.761 149.508 116.398 152.162 116.289C154.825 116.18 157.777 116.326 160.526 116.569C163.276 116.812 165.828 117.152 167.692 117.43C168.625 117.57 169.385 117.694 169.913 117.784C169.925 117.786 169.937 117.788 169.949 117.79C169.848 117.682 169.735 117.561 169.61 117.425C169.064 116.833 168.295 115.984 167.407 114.954C165.631 112.896 163.373 110.113 161.453 107.222C159.537 104.338 157.938 101.32 157.507 98.7932C157.291 97.5283 157.362 96.3544 157.867 95.3755C158.378 94.3856 159.307 93.6412 160.71 93.2032L160.807 93.674C159.509 94.0792 158.723 94.7401 158.298 95.5639C157.867 96.3986 157.784 97.4469 157.991 98.6588C158.405 101.086 159.958 104.04 161.87 106.917C163.777 109.788 166.022 112.556 167.792 114.608C168.677 115.633 169.442 116.479 169.986 117.068C170.258 117.363 170.475 117.593 170.623 117.75C170.697 117.828 170.755 117.888 170.793 117.929L170.837 117.974L170.851 117.989ZM170.667 118.171L170.597 118.414L171.41 118.565L170.851 117.989L170.667 118.171Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.1114 81.0338C120.08 85.2513 141.787 94.5835 156.727 108.598L156.372 108.976C141.507 95.0315 119.883 85.7269 96.9733 81.5202C74.0634 77.3136 49.8919 78.2093 29.9415 84.6397L29.8397 84.1704C49.8868 77.7089 74.1424 76.8163 97.1114 81.0338Z"
        fill="white"
      />
    </svg>
  );
};
export {
  LogoIcon,
  GitHubIcon,
  FigmaIcon,
  LinkedinIcon,
  RightArrowIcon,
  LiveIcon,
  GitHubWhiteIcon,
  FigmaWhiteIcon,
  LinkedinWhiteIcon,
  AzerIcon,
  ArrayIcon
};
